import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["excludedWorkflows"],
  _excluded2 = ["excludedWorkflows"];
import { List } from 'immutable';
import { createImmutableObjectClass } from 'immutable-less/ImmutableObject';
export default class UnenrollmentSetting extends createImmutableObjectClass({
  type: null,
  excludedWorkflows: []
}, {
  fromJSON: _ref => {
    let {
        excludedWorkflows
      } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);
    return Object.assign({}, rest, {
      excludedWorkflows: List(excludedWorkflows || [])
    });
  },
  toJSON: _ref2 => {
    let {
        excludedWorkflows
      } = _ref2,
      rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);
    return Object.assign({}, rest, {
      excludedWorkflows: excludedWorkflows.toJS()
    });
  }
}) {}